<figure class="preview-container">
  <ul class="layers">
    @for (door of doors; track door.id) {
      <li
        class="sublayer front"
        [ngStyle]="{
          'margin-left': isOffset(door.id) ? calculateOffset(door.id) : null,
        }">

        <!-- Image calque — en flux normal pour fixer la hauteur du sublayer -->
        @if (door.layer) {
          <img [src]="baseImgURL + door.layer.layer" alt="" />
        }

        <!-- Sections colorées (lecture seule, non interactives) -->
        @if (door.sections?.length > 0) {
          <div class="sections-container">
            @for (section of door.sections; track section.index) {
              <div
                class="door-section fixed"
                [style.height]="section.heightPercentage + '%'"
                [style.background-image]="getSectionBackground(section)">
              </div>
            }
          </div>

          <!-- Profilé superposé par-dessus les sections -->
          @if (door.layer) {
            <img [src]="baseImgURL + door.layer.layer" class="layer-frame" alt="" />
          }
        }
      </li>
    }
  </ul>
</figure>
<div class="preview-floor"></div>
